import React, { useContext, useEffect, useMemo, useState } from "react";
import { useSnackbar } from "notistack";
import {
  Button,
  List,
  ListItemText,
  Paper,
  ListItemIcon,
  TextField,
  Dialog,
  ListItemButton,
  Autocomplete,
  CircularProgress,
  Grid,
  MenuItem,
} from "@mui/material";
import {
  Delete,
  PostAdd,
  NoteAltOutlined,
  SyncOutlined,
} from "@mui/icons-material";
import { format } from "date-fns";

import GerenciarGuias from "./GerenciarGuias";
import Totalizadores from "./Totalizadores";
import TabelaFaturamento from "./TabelaFaturamento";

import CorpoModal from "../Componentes/CorpoModal";
import Formulario from "../Componentes/Formulario";
import MascaraDeData from "../Componentes/MascaraDeData";
import StatusSincronizacao from "../Componentes/StatusSincronizacao";

import converteDataUS from "../../../utils/converteDataUS";
import DataPickerAtualizado from "../../../components/DataPickerAtualizado";

import { RecebimentoContext } from "../Recebimento/Context/RecebimentoContext";

import { api } from "../../../services/Api";
import { IntervaloDataContext } from "../Context/IntevervaloDataContext";
import { Context as PermissoesContext } from "../../../Context/PermissoesContext";
import { Modal as ModalConfirmacao } from "../../../componentsv2/Modal";
import {
  SincronizacaoFaturamentoContext,
  TIPOS_SINCRONIZACAO,
  obterMensagemErro,
} from "../Context/SincronizacaoFaturamentoContext";
import { solicitarSincronizacaoIndividual } from "../services/sincronizacaoFaturamento";
import useFaturamentoSoftlab from "../hooks/useFaturamentoSoftlab";
import useAcaoLocalFaturamento from "../hooks/useAcaoLocalFaturamento";
import {
  filtrarConvenios,
  obterLabelConvenio,
} from "../convenio";

export default function FaturamentoTabela({ visualizacao = "legado" }) {
  const { enqueueSnackbar } = useSnackbar();

  const [tela, setTela] = useState(0);

  const [opcoes, setOpcoes] = useState(false);
  const [modalProtocolo, setModalProtocolo] = useState(false);
  const [atualizaTabelaFaturamento, setAtualizaTabelaFaturamento] =
    useState(false);
  const [carregandoTabelaLotes, setCarregandoTabelaLotes] = useState(false);

  const [mes_competencia, setMes_competencia] = useState("");
  const [ano_competencia, setAno_competencia] = useState("");
  const [data_previsao, setData_previsao] = useState("");
  const [protocoloAtual, setProtocoloAtual] = useState("");

  const [dadosTabelaFaturamento, setDadosTabelaFaturamento] = useState([]);
  const [totalSoftlabFiltrado, setTotalSoftlabFiltrado] = useState([]);
  const [total, setTotal] = useState([]);
  const [id_lote, setId_lote] = useState("");
  const [codigo, setCodigo] = useState("");
  const [abertura, setAbertura] = useState(null);
  const [valor, setValor] = useState("");
  const [plano, setPlano] = useState("");
  const [codigoLote, setCodigoLote] = useState("");
  const [quantidade, setQuantidade] = useState("");
  const [dataEnvioLote, setDataEnvioLote] = useState("");
  const [idProtocolo, setIdProtocolo] = useState("");
  const [valorAlterado, setValorAlterado] = useState(0);
  const [tipoLote, setTipoLote] = useState("NORMAL");
  const [filtroLotesProtocolo, setFiltroLotesProtocolo] = useState("");
  const [filtroLotesPlano, setFiltroLotesPlano] = useState([
    { id: 0, convenio: "Todos" },
  ]);
  const [filtroLotesResponsavelPlano, setFiltroLotesResponsavelPlano] =
    useState([{ id: 0, grupo: "Todos" }]);
  const [filtroLotes, setFiltroLotes] = useState("");
  const [filtroLotesSituacao, setFiltroLotesSituacao] = useState("");

  const { checarPermissaoSemLog } = useContext(PermissoesContext);
  const {
    emAndamento: salvandoProtocolo,
    executar: executarSalvamentoProtocolo,
  } = useAcaoLocalFaturamento();
  const {
    emAndamento: atualizandoLote,
    executar: executarAtualizacaoLote,
  } = useAcaoLocalFaturamento();
  const {
    emAndamento: excluindoLote,
    executar: executarExclusaoLote,
  } = useAcaoLocalFaturamento();
  const [openModalConfirmarRemocaoLote, setOpenModalConfirmarRemocaoLote] =
    useState(false);

  const [modalEdita, setModalEdita] = useState(false);

  const {
    resultado,
    setResultado,
    protocolo,
    setProtocolo,
    plano: listaPlanos,
    listaConvenios,
    atualizaGeradoSoftlab,
  } = useContext(RecebimentoContext);

  const {
    dataInicio,
    dataFim,
    competencia,
    competenciaInicial,
    competenciaFinal,
  } = useContext(IntervaloDataContext);
  const { dados: totalSoftlab, loading: loadingGeradoSoftlab } =
    useFaturamentoSoftlab({
      dataInicio,
      dataFim,
      competencia,
      gatilhoAtualizacao: atualizaGeradoSoftlab,
      enqueueSnackbar,
    });
  const {
    obterSincronizacaoLoteAtiva,
    registrarInicio,
    cancelarInicio,
    registrarResultado,
    registrarFalha,
  } = useContext(SincronizacaoFaturamentoContext);

  const sincronizacaoLoteAtiva = obterSincronizacaoLoteAtiva(
    codigoLote,
    plano,
    id_lote,
  );
  const listaConvenio = useMemo(
    () =>
      listaConvenios.filter(
        (item) => item.id !== 0 && item.convenio && item.convenio !== "Todos",
      ),
    [listaConvenios],
  );
  const convenioSelecionado = useMemo(
    () => listaConvenio.find((item) => item.convenio === plano) || null,
    [listaConvenio, plano],
  );

  const fechaOpcoes = () => {
    setOpcoes(false);
    setOpenModalConfirmarRemocaoLote(false);
    setProtocoloAtual("");
    setData_previsao("");
  };

  const fechaModalProtocolo = () => {
    setModalProtocolo(false);
    setProtocoloAtual("");
    setData_previsao("");
  };

  const handleValor = (e) => {
    const valorLimpo = e.target.value.replace(/\D/g, "");

    if (!valorLimpo) {
      setValor(0);
      return;
    }

    const valorNumerico = parseFloat(valorLimpo) / 100;

    if (valorNumerico > valorAlterado) {
      setValor(valorAlterado);
      enqueueSnackbar(
        `O valor não pode ser maior que ${valorAlterado?.toLocaleString(
          "pt-BR",
          {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        )}`,
        {
          variant: "warning",
        }
      );
    } else {
      setValor(valorNumerico);
    }
  };

  useEffect(() => {
    const filtroConvenio = listaPlanos?.map((item) => item.convenio);
    let result = [];

    if (filtroConvenio?.includes("Todos")) {
      result = totalSoftlab;
    } else {
      result = totalSoftlab?.filter((item) => {
        const codGuia = item.cod_guia.trim().toUpperCase();

        // Se "UNIMED" foi selecionado, aceita qualquer convênio que contenha "UNIMED"
        const isUnimed =
          filtroConvenio.includes("UNIMED") && codGuia.includes("UNIMED");

        // Mantém os convênios que foram escolhidos explicitamente
        const isOtherConvenio = filtroConvenio.some((conv) => conv === codGuia);

        return isUnimed || isOtherConvenio;
      });
    }

    const soma = result.reduce((soma, atual) => soma + atual.faturamento, 0);
    setTotalSoftlabFiltrado(soma);
  }, [listaPlanos, totalSoftlab]);

  useEffect(() => {
    (async () => {
      const dataHoje = format(new Date(), "yyyy-MM-dd");

      const somaTotal = dadosTabelaFaturamento.reduce(
        (soma, atual) => soma + atual.valor,
        0
      );
      const somaTotalEnviado = dadosTabelaFaturamento.reduce((soma, atual) => {
        if (atual.protocolo) {
          return soma + atual.valor;
        }
        return soma;
      }, 0);
      const somaTotalRecebido = dadosTabelaFaturamento.reduce((soma, atual) => {
        if (atual.data_previsao && atual.data_previsao <= dataHoje) {
          return soma + atual.valor;
        }
        return soma;
      }, 0);
      const somaTotalAguardando = dadosTabelaFaturamento.reduce(
        (soma, atual) => {
          if (atual.data_previsao && atual.data_previsao > dataHoje) {
            return soma + atual.valor;
          }
          return soma;
        },
        0
      );
      setTotal({
        somaTotal,
        somaTotalEnviado,
        somaTotalRecebido,
        somaTotalAguardando,
      });
    })();
  }, [dadosTabelaFaturamento]);

  useEffect(() => {
    if (abertura) {
      if (abertura.includes("/") && abertura.split("/").length === 2) {
        const mes = abertura.split("/")[0];
        const ano = abertura.split("/")[1];
        setMes_competencia(mes);
        setAno_competencia(ano);
      }
    }
  }, [abertura]);

  async function adicionaProtocolo() {
    if (
      !mes_competencia ||
      !ano_competencia ||
      mes_competencia.length !== 2 ||
      ano_competencia.length !== 4
    ) {
      enqueueSnackbar("Preencha o campo competência.", { variant: "warning" });
      return;
    }
    const previsao = data_previsao ? converteDataUS(data_previsao) : "";

    if (!protocoloAtual) {
      enqueueSnackbar("Protocolo vazio.", { variant: "warning" });
      return;
    } else if (!data_previsao) {
      enqueueSnackbar("Preencha uma data de previsão.", { variant: "warning" });
      return;
    }

    await executarSalvamentoProtocolo(async () => {
      try {
        await api.put(`/v2/faturamento/adicionaProtocolo`, {
          protocolo: protocoloAtual,
          previsao,
          codigo,
          plano,
          mes_competencia,
          ano_competencia,
        });

        fechaModalProtocolo();
        fechaOpcoes();

        setAtualizaTabelaFaturamento((prevState) => !prevState);
        enqueueSnackbar("Protocolo adicionado.", { variant: "success" });
      } catch (e) {
        enqueueSnackbar(
          "Não foi possível adicionar esse protocolo. Por favor, tente novamente.",
          { variant: "error" },
        );
      }
    });
  }

  async function atualizaLote() {
    await executarAtualizacaoLote(async () => {
      try {
        const payload = {
          id_protocolo: idProtocolo,
          id_lote,
          data_envio_lote: dataEnvioLote,
          data_previsao,
          codigo: codigoLote,
          plano,
          protocolo: protocoloAtual,
          valor,
          valor_alterado: valorAlterado,
          quantidade,
          mes_competencia,
          ano_competencia,
          tipo: tipoLote,
        };

        await api.put(`/v2/faturamento/atualizaLote`, payload);

        setModalEdita(false);
        setAtualizaTabelaFaturamento((prevState) => !prevState);
        enqueueSnackbar("Lote Atualizado.", { variant: "success" });
      } catch (e) {
        enqueueSnackbar(
          "Não foi possível atualizar esse lote. Por favor, tente novamente.",
          { variant: "error" },
        );
      }
    });
  }

  async function apagaLote() {
    if (!checarPermissaoSemLog("FAT010")) {
      enqueueSnackbar("Você não tem permissão para realizar esta ação", {
        variant: "error",
      });
      return;
    }

    await executarExclusaoLote(async () => {
      try {
        await api.delete(`/v2/faturamento/deletaLote/${id_lote}`);

        setAtualizaTabelaFaturamento((prevState) => !prevState);
        fechaOpcoes();
        enqueueSnackbar("Lote apagado", { variant: "success" });
      } catch (error) {
        enqueueSnackbar(
          "Não foi possível apagar esse lote. Por favor, tente novamente.",
          {
            variant: "error",
          },
        );
      }
    });
  }

  async function sincronizaLoteIndividual() {
    if (sincronizacaoLoteAtiva) {
      fechaOpcoes();
      enqueueSnackbar("Este lote já está sendo sincronizado.", {
        variant: "info",
      });
      return;
    }

    const execucaoOtimista = registrarInicio({
      tipo: TIPOS_SINCRONIZACAO.SINCRONIZACAO_INDIVIDUAL,
      id_lote,
      codigo_lote: codigoLote,
      convenio: plano,
      mensagem: "Iniciando sincronização do lote...",
    });

    fechaOpcoes();

    try {
      const resultadoSincronizacao = await solicitarSincronizacaoIndividual({
        idLote: id_lote,
        lote: codigoLote,
        convenio: plano,
      });
      const execucao = registrarResultado(
        resultadoSincronizacao,
        execucaoOtimista,
      );
      const lotePendente =
        Number(execucao?.total_pendente_origem) > 0 ||
        [
          "PENDENTE_NA_ORIGEM",
          "ARQUIVO_TISS_INDISPONIVEL",
          "NAO_LOCALIZADO_NA_ORIGEM",
        ].includes(execucao?.situacao);
      const loteNaoEncontrado =
        execucao?.total_encontrado === 0 && !lotePendente;

      enqueueSnackbar(
        execucao?.mensagem ??
          (loteNaoEncontrado
            ? "O lote informado não foi encontrado."
            : "Lote sincronizado com sucesso."),
        {
          variant: lotePendente
            ? "warning"
            : loteNaoEncontrado
              ? "info"
              : "success",
        },
      );
    } catch (erro) {
      const statusHttp = erro?.response?.status;

      if (statusHttp === 409 || statusHttp === 400) {
        cancelarInicio(execucaoOtimista);
        enqueueSnackbar(
          obterMensagemErro(
            erro,
            statusHttp === 409
              ? "Este lote já possui uma sincronização em andamento."
              : "Revise os dados do lote antes de sincronizar novamente.",
          ),
          { variant: "warning" },
        );
        return;
      }

      registrarFalha(erro, execucaoOtimista);
      enqueueSnackbar(
        obterMensagemErro(
          erro,
          statusHttp === 404
            ? "O lote não foi localizado no SoftLab."
            : "Não foi possível sincronizar o lote. Por favor, tente novamente.",
        ),
        { variant: statusHttp === 404 ? "warning" : "error" },
      );
    }
  }

  const opcoesModal = (
    <Paper
      style={{ display: "flex", margin: "1rem", justifyContent: "center" }}
    >
      <ModalConfirmacao
        confirmActionButtonColor="green"
        confirmActionButtonText={excluindoLote ? "Removendo..." : "Confirmar"}
        onClose={setOpenModalConfirmarRemocaoLote}
        open={openModalConfirmarRemocaoLote}
        onClick={apagaLote}
        loading={excluindoLote}
        modalText={"Tem certeza que deseja remover este lote?"}
      />
      <List component="nav" aria-label="main mailbox folders">
        <ListItemButton onClick={() => setModalProtocolo(true)}>
          <ListItemIcon>
            <PostAdd color="success" />
          </ListItemIcon>
          <ListItemText primary="Gerenciar Protocolo" />
        </ListItemButton>
        <ListItemButton
          disabled={Boolean(sincronizacaoLoteAtiva)}
          onClick={() => {
            sincronizaLoteIndividual();
          }}
        >
          <ListItemIcon>
            <SyncOutlined color="success" />
          </ListItemIcon>
          <ListItemText
            primary={
              sincronizacaoLoteAtiva
                ? "Sincronização em andamento"
                : "Sincronizar Lote"
            }
          />
        </ListItemButton>
        <ListItemButton onClick={() => setModalEdita(true)}>
          <ListItemIcon>
            <NoteAltOutlined color="success" />
          </ListItemIcon>
          <ListItemText primary="Editar Lote" />
        </ListItemButton>
        <ListItemButton
          onClick={() => {
            setOpenModalConfirmarRemocaoLote(true);
          }}
        >
          <ListItemIcon>
            <Delete color="error" />
          </ListItemIcon>
          <ListItemText primary="Remover" />
        </ListItemButton>
      </List>
    </Paper>
  );

  const protocoloModal = (
    <Paper sx={{ p: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            id="protocolo"
            autoFocus
            fullWidth
            label="Protocolo"
            defaultValue={protocoloAtual || ""}
            onBlur={(e) => setProtocoloAtual(e.target.value.toUpperCase())}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            id="competencia"
            fullWidth
            label="Competência"
            placeholder="MM/AAAA"
            defaultValue={
              mes_competencia !== ""
                ? `${mes_competencia}/${ano_competencia}`
                : ""
            }
            onBlur={(e) => {
              const competencia = e.target.value;
              const [mes, ano] = competencia.split("/");
              setMes_competencia(mes);
              setAno_competencia(ano);
            }}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            id="data_previsao"
            fullWidth
            placeholder="dd/mm/aaaa"
            required
            label="Data de Previsão"
            value={(() => {
              if (!data_previsao) return "";

              if (
                typeof data_previsao === "string" &&
                data_previsao.includes("-")
              ) {
                try {
                  const date = new Date(data_previsao);
                  if (!isNaN(date.getTime())) {
                    return format(date, "dd/MM/yyyy");
                  }
                } catch (error) {
                  return "";
                }
              }

              return data_previsao;
            })()}
            onChange={(e) => setData_previsao(e.target.value)}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputComponent: MascaraDeData,
            }}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12}>
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setModalProtocolo(false)}
                sx={{ minWidth: "10rem", height: "2.2rem" }}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={adicionaProtocolo}
                disabled={salvandoProtocolo}
                startIcon={
                  salvandoProtocolo ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : undefined
                }
                sx={{
                  minWidth: "10rem",
                  height: "2.2rem",
                  backgroundColor: "green",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "darkgreen",
                  },
                }}
              >
                {salvandoProtocolo ? "Salvando..." : "Salvar"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );

  const editaModal = (
    <Paper sx={{ p: 3, width: "100%", maxWidth: "800px" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            id="protocolo"
            autoFocus
            fullWidth
            label="Protocolo"
            value={protocoloAtual}
            onChange={(e) => setProtocoloAtual(e.target.value)}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="codigoLote"
            fullWidth
            label="Lote"
            value={codigoLote}
            onChange={(e) => setCodigoLote(e.target.value)}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Autocomplete
            fullWidth
            options={listaConvenio}
            required
            value={convenioSelecionado}
            getOptionLabel={obterLabelConvenio}
            filterOptions={filtrarConvenios}
            isOptionEqualToValue={(option, value) =>
              option?.convenio === value?.convenio
            }
            onChange={(_event, value) => {
              setPlano(value?.convenio || "");
            }}
            renderInput={(params) => (
              <TextField {...params} label="Convênio" variant="outlined" />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="tipoLote"
            label="Tipo"
            select
            required
            fullWidth
            value={tipoLote}
            onChange={event => setTipoLote(event.target.value)}
            variant="outlined"
          >
            <MenuItem value="NORMAL">Normal</MenuItem>
            <MenuItem value="INTERNO">Interno</MenuItem>
            <MenuItem value="PENDENCIA">Pendência</MenuItem>
            <MenuItem value="NEGOCIACAO">Negociação</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={6} sm={6}>
          <TextField
            id="mesCompetencia"
            label="Mês"
            placeholder="MM"
            value={mes_competencia}
            onChange={(e) => setMes_competencia(e.target.value)}
            inputProps={{ maxLength: 2, inputMode: "numeric" }}
            fullWidth
            variant="outlined"
            required
          />
        </Grid>

        <Grid item xs={6} sm={6}>
          <TextField
            id="anoCompetencia"
            label="Ano"
            placeholder="AAAA"
            value={ano_competencia}
            onChange={(e) => setAno_competencia(e.target.value)}
            inputProps={{ maxLength: 4, inputMode: "numeric" }}
            fullWidth
            variant="outlined"
            required
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DataPickerAtualizado
            data={data_previsao}
            labelName="Data Previsão"
            setData={setData_previsao}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="valor_alterado"
            fullWidth
            label="Valor Softlab"
            placeholder="R$ 0,00"
            value={valorAlterado?.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
            disabled
            variant="outlined"
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="valor"
            fullWidth
            label="Valor do Lote"
            placeholder="R$ 0,00"
            value={valor?.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            onChange={(e) => handleValor(e)}
            variant="outlined"
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id="quantidade"
            fullWidth
            label="Quantidade"
            value={quantidade}
            onChange={(e) => setQuantidade(e.target.value)}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DataPickerAtualizado
            data={dataEnvioLote}
            labelName="Data Envio do Lote"
            setData={setDataEnvioLote}
          />
        </Grid>

        <Grid item xs={12}>
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setModalEdita(false)}
                sx={{ minWidth: "10rem", height: "2.2rem" }}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={atualizaLote}
                disabled={atualizandoLote}
                startIcon={
                  atualizandoLote ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : undefined
                }
                sx={{
                  minWidth: "10rem",
                  height: "2.2rem",
                  backgroundColor: "green",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "darkgreen",
                  },
                }}
              >
                {atualizandoLote ? "Atualizando..." : "Atualizar"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );

  const faturamento = (
    <div className={visualizacao === "lotes" ? "container-lotes-faturamento" : undefined}>
      <StatusSincronizacao />

      <Formulario
        faturamento
        visualizacao={visualizacao}
        filtroProtocolo={visualizacao === "lotes" ? filtroLotesProtocolo : undefined}
        setFiltroProtocolo={visualizacao === "lotes" ? setFiltroLotesProtocolo : undefined}
        filtroPlano={visualizacao === "lotes" ? filtroLotesPlano : undefined}
        setFiltroPlano={visualizacao === "lotes" ? setFiltroLotesPlano : undefined}
        filtroResponsavelPlano={visualizacao === "lotes" ? filtroLotesResponsavelPlano : undefined}
        setFiltroResponsavelPlano={visualizacao === "lotes" ? setFiltroLotesResponsavelPlano : undefined}
        filtroLote={visualizacao === "lotes" ? filtroLotes : undefined}
        setFiltroLote={visualizacao === "lotes" ? setFiltroLotes : undefined}
        filtroSituacao={
          visualizacao === "lotes" ? filtroLotesSituacao : undefined
        }
        setFiltroSituacao={
          visualizacao === "lotes" ? setFiltroLotesSituacao : undefined
        }
        setDadosTabelaFaturamento={setDadosTabelaFaturamento}
        tabelaFaturamento={resultado}
        setAtualizaTabelaFaturamento={setAtualizaTabelaFaturamento}
        carregandoTabela={
          visualizacao === "lotes" ? carregandoTabelaLotes : undefined
        }
      />

      <Totalizadores
        visualizacao={visualizacao}
        total={total}
        totalSoftlabFiltrado={totalSoftlabFiltrado}
        loadingGeradoSoftlab={loadingGeradoSoftlab}
        dadosTabelaFaturamento={dadosTabelaFaturamento}
        listaConvenios={listaConvenio}
        setAtualizaTabelaFaturamento={setAtualizaTabelaFaturamento}
      />

      <TabelaFaturamento
        visualizacao={visualizacao}
        setResultado={setResultado}
        dadosTabelaFaturamento={dadosTabelaFaturamento}
        setDadosTabelaFaturamento={setDadosTabelaFaturamento}
        atualizaTabelaFaturamento={atualizaTabelaFaturamento}
        setCarregandoTabelaLotes={
          visualizacao === "lotes" ? setCarregandoTabelaLotes : undefined
        }
        competenciaInicial={competenciaInicial}
        competenciaFinal={competenciaFinal}
        setId_lote={setId_lote}
        setCodigoLote={setCodigoLote}
        setIdProtocolo={setIdProtocolo}
        setCodigo={setCodigo}
        setPlano={setPlano}
        setAbertura={setAbertura}
        setValor={setValor}
        setValorAlterado={setValorAlterado}
        setProtocolo={setProtocolo}
        setMes_competencia={setMes_competencia}
        setAno_competencia={setAno_competencia}
        setData_previsao={setData_previsao}
        setOpcoes={setOpcoes}
        setProtocoloAtual={setProtocoloAtual}
        setAtualizaTabelaFaturamento={setAtualizaTabelaFaturamento}
        setQuantidade={setQuantidade}
        setDataEnvioLote={setDataEnvioLote}
        setTipoLote={setTipoLote}
        protocoloFiltro={visualizacao === "lotes" ? filtroLotesProtocolo : undefined}
        planoFiltro={visualizacao === "lotes" ? filtroLotesPlano : undefined}
        loteFiltro={visualizacao === "lotes" ? filtroLotes : undefined}
        situacaoFiltro={visualizacao === "lotes" ? filtroLotesSituacao : undefined}
      />

      <Dialog
        maxWidth="sm"
        open={opcoes}
        onClose={fechaOpcoes}
        closeAfterTransition
      >
        <CorpoModal titulo="Opções" fechaModal={fechaOpcoes}>
          {opcoesModal}
        </CorpoModal>
      </Dialog>
      <Dialog
        maxWidth="sm"
        open={modalProtocolo}
        onClose={() => setModalProtocolo(false)}
        closeAfterTransition
      >
        <CorpoModal
          titulo="Gerenciar Protocolo"
          fechaModal={() => setModalProtocolo(false)}
        >
          {protocoloModal}
        </CorpoModal>
      </Dialog>
      <Dialog
        fullWidth // Take up the full width available
        open={modalEdita}
        onClose={() => setModalEdita(false)}
        closeAfterTransition
        scroll="paper" // Enable scrolling if content overflows
      >
        <CorpoModal
          titulo="Editar Lote"
          fechaModal={() => setModalEdita(false)}
        >
          {editaModal}
        </CorpoModal>
      </Dialog>
    </div>
  );

  return (
    <>
      {tela === 0 && faturamento}
      {tela === 1 && (
        <GerenciarGuias
          id_lote={id_lote}
          plano={plano}
          abertura={abertura}
          valor={valor}
          protocolo={protocolo}
          setTela={setTela}
          fechaOpcoes={fechaOpcoes}
        />
      )}
    </>
  );
}
